// Generated by npm run icons:generate. Do not edit.
// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
import { MaterialSymbol, type MaterialIconProps } from "./material-symbol";

const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m330-444 176.21 176.21Q517-257 517-242.5t-11 25.98Q495-206 480.5-206t-25.31-10.82L217.4-454.91q-5.4-5.41-7.9-11.72-2.5-6.31-2.5-13.53 0-7.21 2.5-13.53Q212-500 217-505l238-238q11-11 25.67-11 14.66 0 25.33 11 11 10.67 11 25.33 0 14.67-10.84 25.51L330-516h402.02q15.29 0 25.64 10.29Q768-495.42 768-480.21t-10.34 25.71Q747.31-444 732.02-444H330Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m330-444 176.21 176.21Q517-257 517-242.5t-11 25.98Q495-206 480.5-206t-25.31-10.82L217.4-454.91q-5.4-5.41-7.9-11.72-2.5-6.31-2.5-13.53 0-7.21 2.5-13.53Q212-500 217-505l238-238q11-11 25.67-11 14.66 0 25.33 11 11 10.67 11 25.33 0 14.67-10.84 25.51L330-516h402.02q15.29 0 25.64 10.29Q768-495.42 768-480.21t-10.34 25.71Q747.31-444 732.02-444H330Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
    ]
  }
} as const;

export function ArrowBackIcon(props: MaterialIconProps) {
  return <MaterialSymbol {...props} symbol="arrow_back" artwork={artwork} />;
}
